// extracted by mini-css-extract-plugin
module.exports = {"h6":"Bar_h6__3_D84","h5":"Bar_h5___b9J8","h4":"Bar_h4__2s1nx","h3":"Bar_h3__2Lljb","h2":"Bar_h2__3NF69","h1":"Bar_h1__3rZaV","bar":"Bar_bar__1S8mx"};